<div class="status-report-header-container">
  <span class="lx-label status-report-header-container__name">{{ params.displayName }}</span>
  <span *ngIf="params.activeStatusCriteria" class="status-report-header-container__selectedHealthParam"> *</span>
  <span *ngIf="params.sortable" class="status-report-header-container__sortable-arrow-container">
    <span class="arrow-up" [ngClass]="{'arrow-current': noSort || ascSort === 'active'}" (click)="onAsc()"></span>
    <span class="arrow-down" [ngClass]="{'arrow-current': noSort || descSort === 'active'}" (click)="onDesc()"></span>
  </span>
</div>